// Oxygen Therapy Form
$('a.oxygen-referral-form').click(function(e) {
    try {
        ga( 'send', 'event', 'PDF Download', 'Download', 'Oxygen Therapy', null, {
            'nonInteraction' : 1 }  );
    } catch( err ) {
        console.error('gtm error');
    }
});

// CPAP Requisition Form
$('a.cpap-requisition-form').click(function(e) {
    try {
        ga( 'send', 'event', 'PDF Download', 'Download', 'CPAP Requisition Form', null, {
            'nonInteraction' : 1 }  );
    } catch( err ) {
        console.error('gtm error');
    }
});

// Newsletter Sign Up
$('#mc-embedded-subscribe').click(function(e) {
    try {
        ga( 'send', 'event', 'Newsletter Sign Up', 'Sign Up', 'Newsletter Sign Up', null, {
            'nonInteraction' : 1 }  );
    } catch( err ) {
        console.error('gtm error');
    }
});



